import { api } from '@api'
import { ContractJobUpdate } from '@types'

interface GetLatestContractUpdateResponse {
  contract: ContractJobUpdate
}

const getContractsUpdate = async () => {
  const response = await api.get<GetLatestContractUpdateResponse>('/log-job/latest-contract')

  return response.data.contract
}
const syncContracts = async () => {
  const response = await api.patch('/sap-items')
  return response
}

export const contractUpdateApi = { getContractsUpdate, syncContracts }
